import CheckboxTreeFilter from "./CheckboxTreeFilter";

class PartnerAccountNameFilter extends CheckboxTreeFilter {
  chipLabelTransform = (x: string) => {
    if (x === "Other") return x;
    const [_type, ...label] = x.split("%-%");
    return label.join("");
  };
}

export default PartnerAccountNameFilter;
